import {apiClient} from '@common/http/query-client';

export type TransferAddonSku = '20gb' | '50gb';

export function transferAddonSkuFromLabel(limit: string): TransferAddonSku {
  return limit === '+50GB' ? '50gb' : '20gb';
}

export async function createTransferAddonCheckout(
  sku: TransferAddonSku,
): Promise<{clientSecret: string}> {
  const {data} = await apiClient.post<{clientSecret: string}>(
    'billing/transfer-addon/checkout',
    {sku},
  );
  return data;
}

export async function createGuestTransferAddonCheckout(
  email: string,
  sku: TransferAddonSku,
): Promise<{clientSecret: string}> {
  const {data} = await apiClient.post<{clientSecret: string}>(
    'billing/guest-transfer-addon/checkout',
    {email, sku},
  );
  return data;
}

export async function confirmTransferAddonPurchase(
  paymentIntentId: string,
): Promise<{transfer_bonus_bytes: number}> {
  const {data} = await apiClient.post<{transfer_bonus_bytes: number}>(
    'billing/transfer-addon/confirm',
    {payment_intent_id: paymentIntentId},
  );
  return data;
}

export async function confirmGuestTransferAddonPurchase(
  email: string,
  paymentIntentId: string,
): Promise<{transfer_bonus_bytes: number}> {
  const {data} = await apiClient.post<{transfer_bonus_bytes: number}>(
    'billing/guest-transfer-addon/confirm',
    {email, payment_intent_id: paymentIntentId},
  );
  return data;
}
